<template>
    <div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" style="height: 490" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="materialClass" label="物料类别"></el-table-column>
                <el-table-column prop="materialClassId" label="物料类别ID" width="180"></el-table-column>
                <el-table-column label="赠品" width="300">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.prize" placeholder="请输入赠品"
                                  @blur="saveMatClass(scope.row)"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getMaterialClass,
        saveMatClass,
    } from '../../api/api';

    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                loading: true,
                form: {
                    id: '',
                    materialClassId: '',
                    materialClass: '',
                    prize: '',
                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getMaterialClass().then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.dataList = [];
                        this.dataList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            saveMatClass(row) {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveMatClass(row).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/aiCall/matClass.vue